import { useState } from "react";

function CustomerTimeline({
  cardStyle,
  sectionTitleStyle,
  emptyBoxStyle,
  timelineCliente = [],
  formatDate,
  onOpenPlant,
}) {
  const [timelineFilter, setTimelineFilter] = useState("all");
  const [searchTimeline, setSearchTimeline] = useState("");
  const [timelineAperta, setTimelineAperta] = useState(true);

  const getEventConfig = (tipo) => {
    const type = (tipo || "").toLowerCase();

    if (type.includes("impianto")) {
      return {
        label: "Impianto",
        icon: "🏠",
        color: "#0f3c75",
        background: "#dbeafe",
        text: "#1e40af",
        description: "Impianto collegato al cliente",
      };
    }

    if (type.includes("intervento")) {
      return {
        label: "Intervento",
        icon: "🔧",
        color: "#16a34a",
        background: "#dcfce7",
        text: "#166534",
        description: "Attività tecnica eseguita",
      };
    }

    if (type.includes("manutenzione")) {
      return {
        label: "Manutenzione",
        icon: "🛠️",
        color: "#d97706",
        background: "#fef3c7",
        text: "#92400e",
        description: "Attività manutentiva programmata",
      };
    }

    if (type.includes("scadenza") || type.includes("verifica")) {
      return {
        label: "Verifica",
        icon: "⚠️",
        color: "#dc2626",
        background: "#fee2e2",
        text: "#991b1b",
        description: "Scadenza o controllo tecnico",
      };
    }

    if (type.includes("documento")) {
      return {
        label: "Documento",
        icon: "📄",
        color: "#2563eb",
        background: "#dbeafe",
        text: "#1e40af",
        description: "Documento collegato al cliente",
      };
    }

    return {
      label: "Evento",
      icon: "•",
      color: "#64748b",
      background: "#e2e8f0",
      text: "#334155",
      description: "Attività registrata",
    };
  };

  const getPlantIdFromItem = (item) => {
    if (item.plant_id) return item.plant_id;
    if (item.impianto_id) return item.impianto_id;

    if (typeof item.id === "string" && item.id.startsWith("impianto-")) {
      return item.id.replace("impianto-", "");
    }

    return item.id;
  };

  const matchesFilter = (item, filter) => {
    const tipo = (item.tipo || "").toLowerCase();

    if (filter === "all") return true;
    if (filter === "impianti") return tipo.includes("impianto");
    if (filter === "interventi") return tipo.includes("intervento");
    if (filter === "manutenzioni") return tipo.includes("manutenzione");
    if (filter === "verifiche")
      return tipo.includes("scadenza") || tipo.includes("verifica");
    if (filter === "documenti") return tipo.includes("documento");

    return true;
  };

  const matchesSearch = (item) => {
    const search = searchTimeline.trim().toLowerCase();

    if (!search) return true;

    return (
      item.tipo?.toLowerCase().includes(search) ||
      item.titolo?.toLowerCase().includes(search) ||
      item.descrizione?.toLowerCase().includes(search) ||
      formatDate(item.data).toLowerCase().includes(search)
    );
  };

  const filteredTimeline = timelineCliente.filter(
    (item) => matchesFilter(item, timelineFilter) && matchesSearch(item)
  );

  const groupedTimeline = filteredTimeline.reduce((groups, item) => {
    const dateKey = formatDate(item.data);

    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }

    groups[dateKey].push(item);
    return groups;
  }, {});

  const getFilterCount = (filter) =>
    timelineCliente.filter(
      (item) => matchesFilter(item, filter) && matchesSearch(item)
    ).length;

  const resetFilters = () => {
    setTimelineFilter("all");
    setSearchTimeline("");
  };

  const hasManyItems = filteredTimeline.length > 4;

  const ultimaAttivita =
    timelineCliente.length > 0 ? formatDate(timelineCliente[0].data) : null;

  return (
    <div style={cardStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "16px",
          marginBottom: "6px",
        }}
      >
        <div>
          <h2 style={sectionTitleStyle}>
            Timeline cliente ({timelineCliente.length})
          </h2>

          {ultimaAttivita && (
            <div
              style={{
                color: "#64748b",
                fontSize: "13px",
                marginTop: "6px",
                fontWeight: 600,
              }}
            >
              Ultima attività registrata il {ultimaAttivita}
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={() => setTimelineAperta(!timelineAperta)}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#dbeafe";
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(15,60,117,0.12)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#f1f5f9";
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
          style={{
            border: "1px solid #dbe4f0",
            background: "#f1f5f9",
            color: "#0f3c75",
            borderRadius: "8px",
            padding: "8px 14px",
            cursor: "pointer",
            fontWeight: 700,
            fontSize: "14px",
            transition: "all 0.2s ease",
          }}
        >
          {timelineAperta ? "▲ Chiudi" : "▼ Apri"}
        </button>
      </div>

      {timelineAperta && (
        <>
          <p
            style={{
              color: "#64748b",
              fontSize: "14px",
              marginTop: "8px",
              marginBottom: 0,
              lineHeight: "1.5",
            }}
          >
            Cronologia delle attività collegate al cliente: impianti,
            interventi, manutenzioni, verifiche e documenti.
          </p>

          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              marginTop: "16px",
            }}
          >
            <input
              type="text"
              placeholder="Cerca nella timeline cliente..."
              value={searchTimeline}
              onChange={(e) => setSearchTimeline(e.target.value)}
              style={{
                flex: 1,
                padding: "11px 13px",
                border: "1px solid #cbd5e1",
                borderRadius: "10px",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            {(searchTimeline || timelineFilter !== "all") && (
              <button
                type="button"
                onClick={resetFilters}
                style={{
                  border: "1px solid #dbe4f0",
                  background: "#f8fafc",
                  color: "#0f3c75",
                  borderRadius: "10px",
                  padding: "10px 13px",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: "13px",
                }}
              >
                Azzera
              </button>
            )}
          </div>

          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              marginTop: "14px",
            }}
          >
            {[
              ["all", "Tutti"],
              ["impianti", "Impianti"],
              ["interventi", "Interventi"],
              ["manutenzioni", "Manutenzioni"],
              ["verifiche", "Verifiche"],
              ["documenti", "Documenti"],
            ].map(([value, label]) => (
              <button
                key={value}
                type="button"
                onClick={() => setTimelineFilter(value)}
                onMouseEnter={(e) => {
                  if (timelineFilter !== value) {
                    e.currentTarget.style.background = "#dbeafe";
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(15,60,117,0.12)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (timelineFilter !== value) {
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }
                }}
                style={{
                  border: "1px solid #dbe4f0",
                  borderRadius: "999px",
                  padding: "7px 12px",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: "12px",
                  transition: "all 0.2s ease",
                  background:
                    timelineFilter === value ? "#dbeafe" : "#ffffff",
                  color: timelineFilter === value ? "#1e40af" : "#334155",
                  boxShadow:
                    timelineFilter === value
                      ? "0 2px 6px rgba(15,60,117,0.10)"
                      : "none",
                }}
              >
                {label} ({getFilterCount(value)})
              </button>
            ))}
          </div>

          {filteredTimeline.length !== timelineCliente.length && (
            <div
              style={{
                marginTop: "12px",
                color: "#64748b",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              Visualizzati {filteredTimeline.length} eventi su{" "}
              {timelineCliente.length}.
            </div>
          )}

          {timelineCliente.length === 0 ? (
            <div style={{ ...emptyBoxStyle, marginTop: "14px" }}>
              Nessuna attività registrata per questo cliente.
            </div>
          ) : filteredTimeline.length === 0 ? (
            <div style={{ ...emptyBoxStyle, marginTop: "14px" }}>
              Nessuna attività trovata per il filtro o la ricerca selezionata.
            </div>
          ) : (
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "22px",
                maxHeight: hasManyItems ? "560px" : "none",
                overflowY: hasManyItems ? "auto" : "visible",
                paddingRight: hasManyItems ? "8px" : 0,
              }}
            >
              {Object.entries(groupedTimeline).map(([date, items]) => (
                <div key={date}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      style={{
                        color: "#173a63",
                        fontSize: "15px",
                        fontWeight: 800,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {date}
                    </div>

                    <div
                      style={{
                        height: "1px",
                        background: "#dbe4f0",
                        flex: 1,
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {items.map((item) => {
                      const config = getEventConfig(item.tipo);
                      const isPlantEvent = (item.tipo || "")
                        .toLowerCase()
                        .includes("impianto");
                      const plantId = getPlantIdFromItem(item);
                      const isClickablePlant =
                        isPlantEvent && onOpenPlant && plantId;

                      return (
                        <div
                          key={item.id}
                          onClick={() => {
                            if (isClickablePlant) {
                              onOpenPlant(plantId);
                            }
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                              "0 6px 16px rgba(15,60,117,0.10)";
                            if (isClickablePlant) {
                              e.currentTarget.style.background = "#eef5ff";
                            }
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                            e.currentTarget.style.background = "#f8fbff";
                          }}
                          style={{
                            borderLeft: `4px solid ${config.color}`,
                            paddingLeft: "22px",
                            background: "#f8fbff",
                            borderRadius: "0 12px 12px 0",
                            paddingTop: "12px",
                            paddingBottom: "12px",
                            paddingRight: "14px",
                            transition: "all 0.18s ease",
                            cursor: isClickablePlant ? "pointer" : "default",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <span>{config.icon}</span>

                            <span
                              style={{
                                background: config.background,
                                color: config.text,
                                borderRadius: "999px",
                                padding: "4px 9px",
                                fontSize: "12px",
                                fontWeight: 800,
                              }}
                            >
                              {config.label}
                            </span>

                            <span
                              style={{
                                color: "#64748b",
                                fontSize: "12px",
                              }}
                            >
                              {config.description}
                            </span>
                          </div>

                          <div
                            style={{
                              color: "#173a63",
                              fontWeight: 800,
                              fontSize: "15px",
                              marginBottom: "6px",
                            }}
                          >
                            {item.titolo || "Attività registrata"}

                            {isClickablePlant && (
                              <span
                                style={{
                                  marginLeft: "10px",
                                  color: "#0f3c75",
                                  fontSize: "13px",
                                  fontWeight: 800,
                                }}
                              >
                                →
                              </span>
                            )}
                          </div>

                          <div
                            style={{
                              color: "#4b5563",
                              lineHeight: "1.5",
                              fontSize: "14px",
                            }}
                          >
                            {item.descrizione || "—"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default CustomerTimeline;